import { Link, Navigate } from "react-router-dom";
import { useMe } from "../auth/AuthContext";
import { Notice } from "../components/ui";
import { t } from "../i18n/t";
import { routes } from "../lib/routes";
import { usePageTitle } from "../lib/usePageTitle";

/** `/`: go straight to the only kommune, or let the user pick when there are several. */
export function HomePage() {
  const me = useMe();
  usePageTitle(t("home.title"));
  const options = me.orgs.flatMap((o) => o.kommuner.map((k) => ({ org: o, k })));
  const only = options.length === 1 ? options[0] : undefined;
  if (only) return <Navigate to={routes.dashboard(only.org.org_id, only.k.nummer)} replace />;

  return (
    <div className="page narrow">
      <h1>{t("home.title")}</h1>
      {me.user.is_platform_admin && (
        <p>
          <Link to={routes.admin()} className="btn btn-secondary">
            {t("home.adminLink")}
          </Link>
        </p>
      )}
      {me.orgs.length === 0 && (
        <Notice kind="info">
          <p>{t("home.noOrgs")}</p>
        </Notice>
      )}
      {options.length > 1 && <p className="muted">{t("home.intro")}</p>}
      {me.orgs.map((org) => (
        <section key={org.org_id} className="card" aria-labelledby={`org-${org.org_id}`}>
          <h2 id={`org-${org.org_id}`}>{t("home.orgKommuner", { org: org.org_name })}</h2>
          {org.kommuner.length === 0 ? (
            <p className="muted">{t("home.noKommuner")}</p>
          ) : (
            <ul className="picker-list">
              {org.kommuner.map((k) => (
                <li key={k.nummer}>
                  <Link to={routes.dashboard(org.org_id, k.nummer)}>
                    <span className="picker-name">{k.navn || k.nummer}</span>
                    <span className="muted">{k.nummer}</span>
                  </Link>
                </li>
              ))}
            </ul>
          )}
          <p>
            <Link to={routes.members(org.org_id)}>
              {t("home.membersLink", { org: org.org_name })}
            </Link>
          </p>
        </section>
      ))}
    </div>
  );
}
